import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useFormData } from '../data/useFormData';
import { useCallback, useEffect } from 'react';
import { usePortalData } from '../data/usePortalData';
import { useTicketCreation } from '../components/TicketCreationProvider';
import { useLoginVerify } from '../data/useLoginVerify';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import { HubSpotForm } from 'portals-platform-lib';
import { jsx as _jsx } from "react/jsx-runtime";
export function TicketCreation() {
  const loginVerify = useLoginVerify();
  const {
    close
  } = useTicketCreation();
  const formData = useFormData();
  const portalData = usePortalData();
  const {
    portalId,
    env,
    region
  } = portalData.data;
  const {
    email
  } = loginVerify.data || {};
  useEffect(() => {
    if (email) {
      const params = new URLSearchParams(window.location.search);
      params.set('email', email);
      window.history.replaceState(null, '', `?${params.toString()}`);
      return () => {
        params.delete('email');
        window.history.replaceState(null, '', `?${params.toString()}`);
      };
    }
  }, [email]);
  const onFormSubmitted = useCallback(() => {
    FloatingAlertStore.addAlert({
      message: I18n.text('customer-portal-app.ticketSubmittedAlert.message'),
      titleText: I18n.text('customer-portal-app.ticketSubmittedAlert.title'),
      type: 'success'
    });
    close();
  }, [close]);
  if (!formData.data) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      marginBlock: "400",
      "aria-label": I18n.text('customer-portal-app.loading')
    });
  }
  return /*#__PURE__*/_jsx(HubSpotForm, {
    formId: formData.data.formGuid,
    editorVersion: formData.data.formCreatedByEditorV2 ? 2 : 1,
    portalId: portalId,
    env: env,
    region: region,
    onFormSubmitted: onFormSubmitted,
    loadingFallback: /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      marginBlock: "400",
      "aria-label": I18n.text('customer-portal-app.loading')
    })
  });
}